import { Link } from 'react-router-dom';
import React, { useMemo } from 'react';
import useGetContentAppLink from './useGetContentAppLink';
import { ContentUsageType } from './useGetContentUsage';

const V3AppUsageItem = ({
  app,
  contentItem,
}: {
  app: V3.App;
  contentItem: { id: string; name: string; type: ContentUsageType };
}) => {
  const getContentAppLink = useGetContentAppLink();
  const link = useMemo(
    () => getContentAppLink({ app, itemId: contentItem.id }),
    [app, contentItem.id, getContentAppLink],
  );

  if (!link) {
    return null;
  }

  return (
    <div>
      {link ? (
        <Link target={'_blank'} to={link}>
          {app.label}
        </Link>
      ) : (
        <span>{contentItem.name}</span>
      )}
    </div>
  );
};

export default V3AppUsageItem;
